import GroupAddController from './group.add.controller';

export default {
    controller: GroupAddController,
    template: require('./group.add.tpl.html')
};
